module.exports = __webpack_public_path__ + "ui-static/img/has-no-licenses.653a981d.svg";